import { useMemo } from 'react';
import useEnabledEntities from './useEnabledEntities';

const useSearchPlaceholder = () => {
  const enabledEntities = useEnabledEntities();

  return useMemo(() => {
    const searchables = ['content', ...enabledEntities];
    if (searchables.length >= 4) {
      return `Search ${searchables.slice(0, 3).join(', ')} and more...`;
    } else if (searchables.length === 3) {
      return `Search ${searchables.slice(0, 2).join(', ')} and ${
        searchables[2]
      }`;
    } else if (searchables.length === 2) {
      return `Search ${searchables[0]} and ${searchables[1]}`;
    }

    return `Search ${searchables[0]}`;
  }, [enabledEntities]);
};

export default useSearchPlaceholder;
